<template>
<section id="forgot">
    <NavbarDefault route="/" />
    <div class="container pt-5 width-880 success">
        <div class="row d-flex justify-content-center">
            <div class="col-10">
                <a :href="urlClient">
                    <Button size="small" type="outline" color="grey">
                        <ArrowDropdown :rotate="90" /> Voltar
                    </Button>
                </a>
            </div>
            <div class="col-8 text-center">
                <h2 :class="`c-${getPrimaryColor}four`">E-mail de recuperação enviado!</h2>
                <p class="c-ndarkfour">
                    Seu e-mail de recuperação foi enviado para <b>{{ email }}</b>. <br> Por favor, cheque sua caixa de entrada e siga os passos no e-mail.
                </p>
                <Email class="mt-5" :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor" />
            </div>
        </div>
    </div>
    <Footer />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import Email from '@/components/ilustra/Email'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import Footer from '@/components/navigation/footer/Footer'

export default {
    components: {
        NavbarDefault,
        ArrowDropdown,
        Email,
        Footer,
    },
    data() {
        return {
        }
    },
    computed: {
        email() {
            return localStorage.email
        },
        urlClient() {
            return this.getServiceUrls.CLIENT
        }
    },
    created() {
        this.$store.commit('user/resetState')
        this.$store.commit('companies/resetState')
        this.$store.commit('register/resetState')
    }
}
</script>

<style>
.width-880 {
    max-width: 880px;
}
</style>
